import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "section__inner" }
const _hoisted_2 = { class: "Video__Subinner section__subinner" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "Video__PlayPause" }
const _hoisted_8 = {
  key: 0,
  viewBox: "0 0 12 16"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-video-play" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 1,
  viewBox: "0 0 12 16"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-video-pause" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "Video__Time" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "Video__Play__Icon" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "Video__Play__Background color--1" }),
  /*#__PURE__*/_createElementVNode("svg", {
    viewBox: "0 0 12 16",
    class: "color--2"
  }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-video-play" })
  ])
], -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "Video__Loading" }
const _hoisted_18 = { viewBox: "0 0 120 120" }
const _hoisted_19 = {
  cx: "60",
  cy: "60",
  r: "57",
  ref: "loadingProgress"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass([ 'Video', 'mouse--' + _ctx.mouseState, 'video--' + _ctx.state, _ctx.hasBeenPlayed ? '' : 'video--never-played', _ctx.waiting ? 'video--waiting' : '' ])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("figure", {
          onMousemove: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.mouseMove && _ctx.mouseMove(...args)))
        }, [
          _createElementVNode("video", {
            ref: "video",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.togglePlayPause && _ctx.togglePlayPause(...args))),
            playsinline: ""
          }, [
            (_ctx.Viewport.isMobile && _ctx.slide.video?.mobile)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_ctx.slide.video?.mobile?.webm)
                    ? (_openBlock(), _createElementBlock("source", {
                        key: 0,
                        src: _ctx.slide.video?.mobile?.webm,
                        type: "video/webm"
                      }, null, 8, _hoisted_3))
                    : _createCommentVNode("", true),
                  (_ctx.slide.video?.mobile?.mp4)
                    ? (_openBlock(), _createElementBlock("source", {
                        key: 1,
                        src: _ctx.slide.video?.mobile?.mp4,
                        type: "video/mp4"
                      }, null, 8, _hoisted_4))
                    : _createCommentVNode("", true)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.slide.video?.webm)
                    ? (_openBlock(), _createElementBlock("source", {
                        key: 0,
                        src: _ctx.slide.video?.webm,
                        type: "video/webm"
                      }, null, 8, _hoisted_5))
                    : _createCommentVNode("", true),
                  (_ctx.slide.video?.mp4)
                    ? (_openBlock(), _createElementBlock("source", {
                        key: 1,
                        src: _ctx.slide.video?.mp4,
                        type: "video/mp4"
                      }, null, 8, _hoisted_6))
                    : _createCommentVNode("", true)
                ], 64))
          ], 512),
          _createElementVNode("ul", {
            class: "Video__Controls",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.mouseMove && _ctx.mouseMove(...args)))
          }, [
            _createElementVNode("li", _hoisted_7, [
              _createElementVNode("button", {
                tabindex: "-1",
                ref: "playpause",
                type: "button",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.togglePlayPause && _ctx.togglePlayPause(...args)))
              }, [
                (this.state == 'pause')
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_8, _hoisted_10))
                  : _createCommentVNode("", true),
                (this.state == 'play')
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_11, _hoisted_13))
                  : _createCommentVNode("", true)
              ], 512)
            ]),
            _createElementVNode("li", {
              class: "Video__Progress",
              ref: "bar",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.progressClick && _ctx.progressClick(...args)))
            }, [
              _createElementVNode("span", {
                style: _normalizeStyle(`transform: translateX(${ this.progress - 100 }%);`)
              }, null, 4)
            ], 512),
            _createElementVNode("li", _hoisted_14, [
              _createElementVNode("span", null, _toDisplayString(_ctx.currentTime), 1)
            ])
          ]),
          _createElementVNode("button", {
            tabindex: "-1",
            class: "Video__Play",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.playVideo && _ctx.playVideo(...args)))
          }, _hoisted_16),
          _createElementVNode("div", _hoisted_17, [
            (_openBlock(), _createElementBlock("svg", _hoisted_18, [
              _createElementVNode("circle", _hoisted_19, null, 512)
            ]))
          ])
        ], 32)
      ])
    ])
  ], 2))
}